import { supabase } from "@/lib/supabase/supabaseClient"
import { UseDeleteSurveyFromSurveyBankProps } from "."

export const deleteSurveyFromSurveyBank = async (survey_id: UseDeleteSurveyFromSurveyBankProps) => {
    return await supabase
        .from('survey_bank')
        .delete()
        .eq('id', survey_id)
        .throwOnError();
}